import React from 'react';

import { sizes } from '../../constants/icon-sizes';

interface XIconProps extends React.SVGAttributes<SVGElement> {
  size: string;
}

export const XIcon: React.FC<XIconProps> = (props) => {
  const size = sizes[props.size] || 12;

  const widthHeight = `${size}px`;
  const viewBox = `0 0 ${size} ${size}`;
  const pathD = `M 0,0 L ${size},${size} M ${size},0 L 0,${size}`;

  return (
    <svg width={widthHeight} height={widthHeight} viewBox={viewBox} {...props}>
      <path d={pathD} />
    </svg>
  );
};
